import { useState, useEffect } from "react";
import {
  getPresidentList,
  getVicePresidentList,
  getCandidateProfile,
  getCandidateParticulars
} from "../../../../api/ph-api";
import RacesPage from "../../../../../components/races/RacesPage";
import { SeoTag, CxenseParseTag } from "../../../../../components/seo/SeoTag";

export const getStaticProps = async () => {
  let presidentialList = await getPresidentList();
  let vPresidentialList = await getVicePresidentList();

  const presidential = [...presidentialList.results];
  const vPresidential = [...vPresidentialList.results];

  await Promise.all(
    presidential.map(async (presidentialItem) => {
    const candidateProfile = await getCandidateProfile(presidentialItem.wp_slug);

    // Get bio
    const bio = [{
      content: [candidateProfile.bio]
    }];
    presidentialItem.bio = bio;

    // Get gaffes
    const candidacyGaffes = await getCandidateParticulars(candidateProfile.candidacy_set[0].id, "gaffes");
    let highlightsControversies = [];
    if (candidacyGaffes.length) {
      highlightsControversies = [{
        label: "Gaffes and Blunders",
        content: candidacyGaffes.map(({ quote, context, source }) => ({
          content:`<em>${quote}</em><br /><br /><p>${context}</p>`,
          source
        }))
      }];
    }
    presidentialItem.highlightsControversies = highlightsControversies;

    // Get promises
    const candidacyPromises = await getCandidateParticulars(candidateProfile.candidacy_set[0].id, "promises");
    let promises = [];
    if (candidacyPromises.length) {
      promises = candidacyPromises.map(({ issue, description, quote, context, source }) => ({
        label: issue,
        content: [{
          header: {
            title: `On ${issue}`,
            body: description
          },
          details: {
            title: `What ${candidateProfile.alternate_name || candidateProfile.first_name} is Saying`,
            body: quote ? `<em>${quote}</em>` : ""
          },
          context: {
            title: "Context",
            body: context ? context : ""
          },
          source
        }]
      }));
    }
    presidentialItem.promises = promises;

    // Get stances
    const candidacyStances = await getCandidateParticulars(candidateProfile.candidacy_set[0].id, "issue_positions");
      let stances = [];

      if (candidacyStances.length) {
        candidacyStances.forEach(stance => {
          const parentStanceIndex = stances.findIndex(existingStance => existingStance.label === stance.issue.parentIssue);
          const content = {
            positionStrength: stance.position_strength,
            header: {
              title: `${stance.issue.name}`,
              body: stance.quote
            },
            details: {
              title: "",
              body: stance.explanation
            },
            context: {
              title: "",
              body: stance.context ? stance.context : ""
            },
            source: stance.source
          }
          if (parentStanceIndex === -1) {
            stances.push({
              label: stance.issue.parentIssue,
              content: [content]
            });
          } else {
            stances[parentStanceIndex].content.push(content);
          }
        });
      }
    presidentialItem.stances = stances;

    presidentialItem.highlightsControversies = highlightsControversies;
    }),
    vPresidential.map(async (vPresidentialItem) => {
      const candidateProfile = await getCandidateProfile(vPresidentialItem.wp_slug);

      // Get bio
      const bio = [{
        content: [candidateProfile.bio]
      }];
      vPresidentialItem.bio = bio;

      // Get gaffes
      const candidacyGaffes = await getCandidateParticulars(candidateProfile.candidacy_set[0].id, "gaffes");
      let highlightsControversies = [];
      if (candidacyGaffes.length) {
        highlightsControversies = [{
          label: "Gaffes and Blunders",
          content: candidacyGaffes.map(({ quote, context, source }) => ({
            content:`<em>${quote}</em><br /><br /><p>${context}</p>`,
            source
          }))
        }];
      }
      vPresidentialItem.highlightsControversies = highlightsControversies;

      // Get promises
      const candidacyPromises = await getCandidateParticulars(candidateProfile.candidacy_set[0].id, "promises");
      let promises = [];
      if (candidacyPromises.length) {
        promises = candidacyPromises.map(({ issue, description, quote, context, source }) => ({
          label: issue,
          content: [{
            header: {
              title: `On ${issue}`,
              body: description
            },
            details: {
              title: `What ${candidateProfile.alternate_name || candidateProfile.first_name} is Saying`,
              body: quote ? `<em>${quote}</em>` : ""
            },
            context: {
              title: "Context",
              body: context ? context : ""
            },
            source
          }]
        }));
      }
      vPresidentialItem.promises = promises;

      // Get stances
      const candidacyStances = await getCandidateParticulars(candidateProfile.candidacy_set[0].id, "issue_positions");
        let stances = [];

        if (candidacyStances.length) {
          candidacyStances.forEach(stance => {
            const parentStanceIndex = stances.findIndex(existingStance => existingStance.label === stance.issue.parentIssue);
            const content = {
              positionStrength: stance.position_strength,
              header: {
                title: `${stance.issue.name}`,
                body: stance.quote
              },
              details: {
                title: "",
                body: stance.explanation
              },
              context: {
                title: "",
                body: stance.context ? stance.context : ""
              },
              source: stance.source
            }
            if (parentStanceIndex === -1) {
              stances.push({
                label: stance.issue.parentIssue,
                content: [content]
              });
            } else {
              stances[parentStanceIndex].content.push(content);
            }
          });
        }
      vPresidentialItem.stances = stances;

      vPresidentialItem.highlightsControversies = highlightsControversies;
    })
  );

  if (!presidential || !vPresidential) {
    return {
      props: { presidential, vPresidential },
      revalidate: 5
    }
  }

  return {
    props: { presidential, vPresidential },
  };
};

export const getStaticParams = () => {
    return ['selectCandidates', 'race'];
}

const TotT = ({ presidential, vPresidential }) => {
  const [url, setUrl] = useState("");
  const title = "2022 Philippine election results | Tale of the Tape";
  const description =
    "Compare presidential and vp candidate highlights, controversies, their promises, and their stances on key issues. You can compare up to 3 candidates at a time.";
  const keywords = "2022 Philippine elections, #PHVote, 2022 Philippine national elections";
  const og_image = "https://www.rappler.com/tachyon/2022/03/ATIN-PILIPINAS.jpg";

  let twitter_title;
  useEffect(() => {
    setUrl(window.location.href);
    twitter_title = `Tale of the Tape - 2022 Philippine elections #PHVote #WeDecide ${window.location.href}`;
  }, []);

  return (
    <>
      <SeoTag
        title={title}
        description={description}
        keywords={keywords}
        og_image={og_image}
        twitter_og_image={og_image}
        twitter_title={twitter_title}
        twitter_description={description}
      />
      <CxenseParseTag title={title} />
      <RacesPage
        path="tale-of-the-tape"
        presidential={presidential}
        vPresidential={vPresidential}
        url={url}
      />
    </>
  );
};

export default TotT;
